import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { ActionRunService } from '@client/app/modules/business-intelligence/run/action.service';
import { BiService } from '@client/app/modules/business-intelligence/services/bi.service';
import { VirtualUrlService } from '@client/app/modules/business-intelligence/services/virtual-urls.service';


export function init_app (actionRunService: ActionRunService) {
    return () => actionRunService.initializeApp();
}

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        VirtualUrlService,
        BiService, provideAppInitializer(() => {
            const initializerFn = (init_app)(inject(ActionRunService));
            return initializerFn();
        })],
})


export class MonBiModule {}
